import { createFileRoute } from '@tanstack/react-router'
import AdminUsersPage from '@/spa/pages/admin/AdminUsersPage'
import { routeErrorComponent } from '../_shared/RouteError'

export const Route = createFileRoute('/admin/users')({
  component: AdminUsersPage,
  errorComponent: routeErrorComponent,
})
